import { useEffect, useRef, useState } from 'react';
import { testimonials } from '@/mocks/audios';

export default function TestimonialsSection() {
  const sectionRef = useRef<HTMLElement>(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section
      id="depoimentos"
      ref={sectionRef}
      className="w-full py-16 md:py-24 bg-background-100"
      aria-label="Depoimentos de clientes"
    >
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div
          className={`text-center mb-12 md:mb-16 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
        >
          <span className="inline-block text-xs md:text-sm font-semibold text-accent-700 uppercase tracking-wider mb-3">
            Depoimentos
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-900 mb-4">
            Quem já transformou a própria vida
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
            Veja o que pessoas reais estão dizendo sobre o poder dos nossos áudios de cura sonora.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6">
          {testimonials.map((t, index) => (
            <article
              key={t.id}
              className={`bg-background-50 border border-background-200/70 rounded-xl p-5 md:p-6 transition-all hover:border-accent-300/50 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}
              style={{ transitionDelay: `${index * 100}ms`, transitionDuration: '700ms' }}
              aria-label={`Depoimento de ${t.name}`}
            >
              <div className="flex gap-0.5 mb-4" aria-label="5 de 5 estrelas">
                {Array.from({ length: 5 }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm" />
                ))}
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-5 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="flex items-center gap-3">
                <div className="w-11 h-11 md:w-12 md:h-12 flex-shrink-0 rounded-full bg-gradient-to-br from-primary-400 to-accent-400 flex items-center justify-center">
                  <span className="text-background-50 font-bold text-sm">{t.initials}</span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.location}</p>
                </div>
                <div className="ml-auto">
                  <span className="inline-flex items-center px-2.5 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium whitespace-nowrap">
                    {t.audio}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}